import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from '../axios';
import {
    Container,
    H1,
    MediumSpacing
} from "../../styles";

const StudentEnrollmentDelete = () => {
    const { id } = useParams(); // Enrollment ID
    const navigate = useNavigate();
    const [enrollment, setEnrollment] = useState(null);

    useEffect(() => {
        axios.get(`/student_enrollment/${id}/`)
            .then(response => {
                setEnrollment(response.data);
            })
            .catch(error => console.error("There was an error fetching the enrollment data!", error));
    }, [id]);

    const handleDelete = () => {
        if (window.confirm("Are you sure you want to delete this enrollment?")) {
            axios.delete(`/student_enrollment/delete/${id}/`)
                .then(() => {
                    navigate(-1); // Go back to the previous page
                })
                .catch(error => {
                    console.error("There was an error deleting the enrollment!", error);
                });
        }
    };

    if (!enrollment) {
        return <div>Loading...</div>;
    }

    return (
        <Container>
            <H1>Delete Student Enrollment</H1>
            <MediumSpacing />
            <p>Are you sure you want to delete the enrollment for {enrollment.student.first_name} {enrollment.student.last_name} in {enrollment.class_enrolled.course_details.name}?</p>
            <button onClick={handleDelete}>Delete</button>
        </Container>
    );
};

export default StudentEnrollmentDelete;
